import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addBrandType, getVehicleModels } from "../../../redux/CarsManagement/BrandTypes/brandTypesSlice";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import MaintenanceSelect from "../../../components/CustomSelect/MaintenanceSelect";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { NavLink } from "react-router-dom";

function BrandTypesActions({ brandName, brandId }) {
  const dispatch = useDispatch();

  const { addBrandTypeModalValues, vehicleModels } = useSelector(
    (state) => state.brandTypes
  );

  const {
    formState: { errors, isValid },
    handleSubmit,
    reset,
    control,
    setValue,
  } = useForm({
    defaultValues: addBrandTypeModalValues,
  });

  // ✅ get models when brand changes
  useEffect(() => {
    if (brandName) {
      dispatch(getVehicleModels(brandName));
    }
  }, [brandName, dispatch]);

  const resetAddBrandTypeModalValues = () => {
    reset(addBrandTypeModalValues);
  };

  // ✅ autofill when model selected
  const handleModelChange = (value) => {
    const selected = vehicleModels.find(
      (m) => m.modelDescription1 === value
    );

    if (selected) {
      setValue("nameEn", selected.modelDescription1);
      setValue("nameAr", selected.modelDescription2);
    }
  };

  const handleAddBrandType = (data) => {
    const payload = {
      brand_id: brandId,
      ...data,
    };

    dispatch(addBrandType(payload));
    resetAddBrandTypeModalValues();
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <NavLink to="/Cars">السيارات</NavLink>
          </li>
          <li>
            <NavLink to="/Brands">المُصنع</NavLink>
          </li>
          <li>
            <span aria-current="page">{brandName}</span>
          </li>
        </ul>

        <button
          className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-position-left"
          uk-toggle="target: #addBrandTypeModal"
        >
          <span className="uk-margin-small-left" uk-icon="plus"></span>
          إنشاء
        </button>
      </nav>

      {/* Modal */}
      <div id="ModalOfAddBrandType">
        <div
          id="addBrandTypeModal"
          uk-modal="bg-close: false"
          container="#ModalOfBrand"
        >
          <div className="uk-modal-dialog">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close=""
              onClick={resetAddBrandTypeModalValues}
            ></button>

            <div className="uk-modal-header uk-text-center">
              <h2 className="uk-modal-title">إضافة نوع</h2>
            </div>

            <div className="uk-modal-body">
              <form className="uk-grid-small uk-child-width-1-2" uk-grid="">

                {/* 🔥 NEW: Models Dropdown */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الموديل
                  </label>

                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="model"
                      control={control}
                      render={({ field }) => (
                        <select
                          className="uk-select"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            handleModelChange(e.target.value);
                          }}
                        >
                          <option value="">اختر الموديل</option>

                          {vehicleModels.map((item, index) => (
                            <option
                              key={index}
                              value={item.modelDescription1}
                            >
                              {item.modelDescription1}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </div>
                </div>

                {/* Arabic */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالعربي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameAr"
                      error={errors.nameAr}
                    />
                  </div>
                </div>

                {/* English */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالإنجليزي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameEn"
                      error={errors.nameEn}
                    />
                  </div>
                </div>

                {/* Order */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الترتيب
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="order"
                      error={errors.order}
                      type="number"
                    />
                  </div>
                </div>

                {/* Status */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الحالة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <StatusSelect field={field} error={errors.status} />
                      )}
                    />
                  </div>
                </div>

                {/* Maintenance */}
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    عرض في الصيانة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="viewinmaintenance"
                      control={control}
                      render={({ field }) => (
                        <MaintenanceSelect
                          field={field}
                          error={errors.viewinmaintenance}
                        />
                      )}
                    />
                  </div>
                </div>

              </form>
            </div>

            <div className="uk-modal-footer uk-text-left">
              <button
                className={`uk-button uk-button-secondary uk-margin-small-left uk-border-rounded${
                  isValid ? " uk-modal-close" : ""
                }`}
                type="button"
                onClick={handleSubmit(handleAddBrandType)}
              >
                إضافه
              </button>

              <button
                className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
                type="button"
                onClick={resetAddBrandTypeModalValues}
              >
                إلغاء
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default BrandTypesActions;